import hash from 'hash.js'
import kebabCase from 'lodash.kebabcase'

export default function getKeyFromString(text: string) {
  const kebabCasedString = kebabCase(text).substring(0, 50)
  const textHash = hash.sha1().update(kebabCasedString).digest('hex')

  return `${kebabCasedString}-${textHash}`
}
